module.exports = __webpack_public_path__ + "static/media/34.ad12ab26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/34.jpg
// module id = 724
// module chunks = 0